import React, { useContext, useEffect } from 'react';
import { Collapse } from 'reactstrap';
import { ShepherdTourContext } from 'react-shepherd';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { ReactComponent as Arrow } from 'assets/img/icons/down-only.svg';

export default function TriggerBtn({
  text = '',
  description = '',
  isVisited = false,
  isExpanded = false,
  onExpand = () => {},
  onStarted = () => {},
  onCancelled = () => {},
  onCompleted = () => {}
}) {
  const tour = useContext(ShepherdTourContext);

  useEffect(() => {
    tour.on('cancel', onCancelled);
    tour.on('complete', onCompleted);
  }, [tour, onCancelled, onCompleted]);

  const onStartTour = () => {
    if (!tour) return;
    tour.start();
    onStarted();
  };

  return (
    <div
      onClick={onExpand}
      className={cn(styles.container, {
        [styles.read]: isVisited,
        [styles.open]: isExpanded
      })}
    >
      <div className={styles.header}>
        <span className={styles.title}>{text}</span>
        <Arrow className={styles.arrow} />
      </div>
      <Collapse isOpen={isExpanded}>
        {description && <p className={styles.description}>{description}</p>}
        <UiKit.Button variant="outline" onClick={onStartTour}>
          {isVisited ? 'Try again' : 'Try it'}
        </UiKit.Button>
      </Collapse>
    </div>
  );
}
